const roundPrice = (price: string | number, isInteger = true) =>
  Math.ceil(+price / (isInteger ? 100 : 1));

export default roundPrice;
